// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    ASSOCIATE_TO_GPS_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    associateToGpsResult,
} from 'Redux/actions';

// Helpers
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* associateToGps({ payload }) {
    try {

        let QUERY = `
            mutation bulkPairing ($pairing: [BulkPairingInput]) {
                result: bulkPairing (pairing: $pairing) {
                    unitIdCamera
                    unitIdGps
                    errorMessage
                    errorCode
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                pairing: [payload]
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result && data?.result.length > 0) {
            yield put(associateToGpsResult(data?.result[0]))
        }

    } catch (exc) {
        yield put(associateToGpsResult({ errorMessage: "It was not possible to pair the devices" }))
        ExceptionManager(exc, 'Modules/devices/views/overview/.components/associateToGps/redux/saga', 'associateToGps');
    }
}

export const getDevices = async (input = '', companyId) => {
    try {
        let QUERY = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        companyId
                        label
                        esn
                        imei
                        deviceModel {
                            id
                            name
                            manufacturerId
                            manufacturer {
                                id
                                name
                            }
                        }
                        linkedByUnit {
                            id
                            companyId
                            label
                            esn
                            imei
                        }
                    }
                    total
                }   
            }
        `
        let conditions = []

        if(companyId){
            conditions.push({
                fields: ["companyId"],
                terms: [companyId],
                exact: true
            })
        }

        if(input){
            conditions.push({
                fields: ["esn", "label", "imei"],
                terms: [input],
                exact: true
            })
        }   
        
        return await clientQuery(QUERY,
            {
                conditions: conditions,
                "limit": 10,
                "offset": 0
            }
            , endpoints.GRAPHQL_GENERAL);

    } catch (exc) {
        ExceptionManager(exc, 'Modules/devices/views/overview/.components/associateToGps/redux/saga', 'getDevices');
    }
}



function* watchMethods() {
    yield takeEvery(ASSOCIATE_TO_GPS_REQUEST, associateToGps);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}